<template>
  <div class="HotArea" ref="HotArea">
    <!-- 热门退货地区 -->
    <div class="panel">
      <div class="header">
        <p class="title">热门退货地区</p>
        <!-- regionType，123分别是省市区 -->
        <div class="showtype" v-if="userInfo.regionType == '1'">
          <div
            @click="regionalReturnRanking('2')"
            class="btn"
            :class="{ 'btn-active': queryType === '2' }"
          >
            州市
          </div>
          <div
            @click="regionalReturnRanking('1')"
            class="btn"
            :class="{ 'btn-active': queryType === '1' }"
          >
            区县
          </div>
        </div>
      </div>

      <div class="table-data">
        <table>
          <tr class="table-head">
            <td align="">排名</td>
            <td>区域</td>
            <td>退货量</td>
            <td>退货占比</td>
          </tr>
          <tr class="table-body" v-for="(item, index) in refundAreaData" :key="index">
            <td class="index">{{ index + 1 }}</td>
            <td style="color: #229f60" @click="toRefundList(item, index)">
              {{ item.F_NAME }}
            </td>
            <td>{{ item.count | numSeparate }}</td>
            <td>{{ item.proportion }}</td>
          </tr>
        </table>
      </div>
      <div
        class="btn"
        style="margin-top: 17px;"
        :class="isMoreRegion ? '' : ' on'"
        @click="showmoreRegion($event)"
        v-if="allRefundAreaData.length >= 5 && queryType == '2'"
      >
        <span class="zhankai-shouqi">{{ !isMoreRegion ? "收起" : "展开" }}</span>
        <img src="../../../../assets/image/ic_jt_ck@2x.png" alt="">
      </div>
      <div
        class="btn-more"
        style="margin-top: 17px;"
        @click="toCountyArea()"
        v-if="allRefundAreaData.length >= 5 && queryType == '1'"
      >
        <span class="zhankai-shouqi">展开</span>
        <img src="../../../../assets/image/ic_jt_ck@2x.png" alt="">

      </div>
    </div>

    <!-- 热门退货服务点 -->
    <div class="panel">
      <div class="header">
        <p class="title">热门退货服务点</p>
      </div>

      <div class="table-data">
        <p v-if="!serviceData.length" style="font-size: 16px;color: #71747A;font-weight: 400;">暂无数据</p>
        <table v-if="serviceData.length > 0">
          <tr class="table-head">
            <td align="">排名</td>
            <td>点位名称</td>
            <td>服务数量</td>
            <td>服务占比</td>
          </tr>
          <tr class="table-body" v-for="(item, index) in serviceData" :key="index">
            <td class="index">{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.count | numSeparate }}</td>
            <td>{{ item.proportion }}</td>
          </tr>
        </table>
      </div>
      <div
        class="btn"
        style="margin-top: 17px;"
        :class="isMoreService ? '' : ' on'"
        @click="showmoreService($event)"
        v-if="allServiceData.length >= 5"
      >
        <span class="zhankai-shouqi">{{ !isMoreService ? "收起" : "展开" }}</span>
        <img src="../../../../assets/image/ic_jt_ck@2x.png" alt="">
      
      </div>
    </div>

    <div class="panel">
      <div class="header">
        <p class="title">热门退货企业</p>
      </div>
      <!-- 264px -->
      <div :style="isMoreEnterprise && columnData.length > 0 ? styleObject : ''" id="box">
        <p v-if="!columnData.length" style="font-size: 16px;color: #71747A;font-weight: 400;">暂无数据</p>
        <verticalColumnar v-if="columnData.length > 0" :columnData="columnData">
        </verticalColumnar>
      </div>
      <div
        class="btn"
        :class="isMoreEnterprise ? '' : 'on'"
        @click="showmoreEnterprise($event)"
        v-if="enterpriseData.length >= 5"
      >
        <span class="zhankai-shouqi">{{ !isMoreEnterprise ? "收起" : "展开" }}</span>
        <img src="../../../../assets/image/ic_jt_ck@2x.png" alt="">

      </div>
    </div>
  </div>
</template>

<script>
    import api from '@/service/modules/refund';
    import verticalColumnar from './chartComponent/verticalColumnar.vue';

    export default {
        filters: {
            numSeparate (value) {
                var rag = /(\d)(?=(?:\d{3})+$)/g;
                if (!value) {
                    return '0';
                } else {
                    if ((value + '').indexOf('.') != -1) {
                        let num = value.toString().split('.');
                        if (num[1].length > 2) num[1] = '00';
                        return num[0].replace(rag, '$1,') + '.' + num[1];
                    }
                    return (value + '').replace(rag, '$1,');
                }
            }
        },
        data () {
            return {
              styleObject: {
                width: '100%',
                height: '305px',
                overflow: 'hidden'
              },
                isMoreRegion: true,
                isMoreService: true,
                isMoreEnterprise: true,
                queryType: '2', // 2为州市，1为区县
                userInfo: {},
                // 热门地区
                allRefundAreaData: [],
                refundAreaData: [],
                // 热们服务点
                allServiceData: [],
                serviceData: [],
                // 热门企业
                enterpriseData: [],
                columnData: [],

                params: {
                    value: '',
                    dataType: '',
                    startTime: this.$store.state.refund.statisticalAnalysisTime.startTime,
                    endTime: this.$store.state.refund.statisticalAnalysisTime.endTime,
                    liftingSequence: '',
                    reginCode: this.$store.state.refund.statisticalAnalysisReginCode,
                    sort: '',
                    orgId: ''
                },
            };
        },
        components: {
            verticalColumnar
        },
        created () {
          this.currentUser();
        },
        mounted () {
        },
        methods: {
            currentUser () {
              console.log('currentUser');
                api.currentUser().then((res) => {
                    if (res.ret === 0) {
                        this.userInfo = res.data
                        // this.params.reginCode = this.userInfo.regionCode;
                        if (this.userInfo.regionType != '1') {
                            this.queryType = '1';
                        }
                        this.initData();
                    } else {
                        this.params.reginCode = '';
                    }
                });
            },
            async initData () {
                 this.regionalReturnRanking();
                 this.fieldService();
                 this.hotspotReturnEnterprise();
            },
            // 请求全部热门退货地区处理数据
            regionalReturnRanking (queryType) {
                this.isMoreRegion = true;
                if (queryType) {
                    this.queryType = queryType;
                }
                return api.regionalReturnRanking(this.params, this.queryType).then((res) => {
                    if (res.ret === 0) {
                        this.allRefundAreaData = res.data.regionalReturnRankingMap;
                        // 给市级的id加上self
                        for (let index = 0; index < this.allRefundAreaData.length; index++) {
                          const element = this.allRefundAreaData[index];
                          if (element.F_NAME === '市级' || element.F_NAME === '省级') {
                            element.cityId = `self${element.cityId}`
                          }
                        }
                        this.refundAreaData = this.allRefundAreaData.slice(0, 5);
                    } else {
                        this.allRefundAreaData = [];
                    }
                });
            },
            // 请求全部热门服务点处理数据
            fieldService () {
                return api.fieldService(this.params).then((res) => {
                    if (res.ret === 0) {
                        this.allServiceData = res.data.fieldServiceMap;
                        this.serviceData = this.allServiceData.slice(0, 5);
                    } else {
                        this.allServiceData = [];
                    }
                });
            },
            // 请求全部热门企业处理数据
            hotspotReturnEnterprise () {
              console.log('请求热门');
                this.enterpriseData = [];
                this.columnData = [];
                return api.hotspotReturnEnterprise(this.params).then((res) => {
                    if (res.ret === 0) {
                        res.data.hotspotReturnEnterpriseMap.forEach((item) => {
                            this.enterpriseData.push({
                                product: [item.centerName, item.cityName],
                                nums: item.count
                            });
                            // this.columnData = this.enterpriseData.slice(0, 5);
                            this.columnData = this.enterpriseData
                        });
                    } else {
                        this.enterpriseData = [];
                    }
                });
            },
            // 展示更多热门退货地区
            showmoreRegion () {
                if (this.isMoreRegion) {
                    this.refundAreaData = this.allRefundAreaData;
                } else {
                    this.refundAreaData = this.allRefundAreaData.slice(0, 5);
                }
                this.isMoreRegion = !this.isMoreRegion;
            },
            // 展示更多服务点
            showmoreService () {
                if (this.isMoreService) {
                    this.serviceData = this.allServiceData;
                } else {
                    this.serviceData = this.allServiceData.slice(0, 5);
                }
                this.isMoreService = !this.isMoreService;
            },
            // 展示更多热门企业
            showmoreEnterprise () {
                // if (this.isMoreEnterprise) {
                //     this.columnData = [];
                //     setTimeout(() => {
                //         this.columnData = this.enterpriseData;
                //     }, 50);
                // } else {
                //     this.columnData = [];
                //     setTimeout(() => {
                //         // this.columnData = this.enterpriseData.slice(0, 5);
                //         this.columnData = this.enterpriseData
                //     }, 50);
                // }
                this.isMoreEnterprise = !this.isMoreEnterprise;
            },

            // 添加时间作为筛选条件
            async timeChange (time) {
                if (time.length > 0) {
                    this.params.startTime = time[0].replace(/\//g, '-');
                    this.params.endTime = time[1].replace(/\//g, '-');

                    this.$store.state.refund.statisticalAnalysisTime.startTime = time[0].replace(/\//g, '-');
                    this.$store.state.refund.statisticalAnalysisTime.endTime = time[1].replace(/\//g, '-');
                }
                await this.initData();
                this.areaOrTimeChangeCallBack();
            },
            // 添加区域作为筛选条件
            async areaChange (area) {

                this.params.reginCode = area;
                this.$store.state.refund.statisticalAnalysisReginCode = area

                await this.initData();
                this.areaOrTimeChangeCallBack();
            },
            areaOrTimeChangeCallBack() {
              let ReturnVolume = 0; // 退货量
              this.allRefundAreaData.map(i => {
                ReturnVolume += i.count
              })
              if (ReturnVolume == 0 && this.serviceData.length === 0 && this.columnData.length === 0) {
                this.$emit('nodata', true)
              } else {
                this.$emit('nodata', false)
              }
            },

            // 跳转退货列表
            toRefundList (item, index) {
              console.log('item', item);
                this.$router.push({
                    path: '/refund/cityAreaRefundList',
                    query: {
                        cityIndex: index,
                        queryType: this.queryType,
                        areaId: item.cityId,
                        areaName: item.F_NAME,
                        startTime: this.$store.state.refund.statisticalAnalysisTime.startTime,
                        endTime: this.$store.state.refund.statisticalAnalysisTime.endTime
                    }
                });
            },

            // 跳转全部区县
            toCountyArea () {
                this.$router.push({
                    path: '/refund/allCounty'
                });
            },
        }
    };
</script>

<style lang="less" scoped>
.HotArea {
  background-color: #f9fafc;
  padding: 12px 12px 90px;
  .panel {
    background-color: white;
    padding: 12px 16px 16px;
    margin-bottom: 12px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      .title {
        font-size: 16px;
        color: #1e2226;
        font-weight: bold;
      }
      .showtype {
        display: flex;
        div:first-child {
          border-radius: 2px 0 0 2px;
        }
        div:last-child {
          border-radius: 0 2px 2px 0;
        }
        .btn {
          border: 1px solid #36b374;
          width: 56px;
          padding: 6px 0;
          text-align: center;
          font-weight: 400;
          font-size: 12px;
          border-radius: 2px;
          color: #36b374;
        }
        .btn-active {
          background: #36b374;
          color: white;
        }
      }
    }
    .table-data {
      table {
        width: 100%;
        border-collapse: collapse;
      }
      .table-head {
        td {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 12px;
          color: #71747A;
        }
      }
      .table-body {
        td {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #1E2226;
        }
        .index {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #171A1D;
        }
      }
      tr {
        line-height: 46px;
        border-bottom: 1px #f5f6f9 solid;
        color: #1e2226;
        td:nth-of-type(1) {
          text-align: center;
        }
        td:nth-of-type(2) {
          width: 135px;
          max-width: 135px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
      tr:first-child {
        line-height: 32px;
        border-bottom: none;
        background: #f9fafc;
        td {
          color: #71747a !important;
          &:nth-of-type(1) {
            text-align: center;
          }
        }
      }
    }

    .btn {
      padding: 0 16px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;

      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 12px;
        height: 12px;
        transform: rotate(90deg);

      }
      span {
        position: relative;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #71747A;
      }
    }
    .btn.on {
        display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 12px;
        height: 12px;
        transform: rotate(-90deg);
      }
    }
    .btn-more {
      padding: 0 16px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;

        display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 12px;
        transform: rotate(90deg);
        height: 12px;
      }
      span {
        position: relative;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #71747A;
      }
    }
  }
}
</style>
